<template>
    <div class="TestQuestionManagement">
        <el-menu 
            :default-active="activeIndex" 
            class="el-menu-demo" 
            mode="horizontal" 
            text-color="#828181"
            @select="handleSelect"
            active-text-color="#0080ff"
        >
            <el-menu-item index="1">我的试题</el-menu-item>
            <el-menu-item index="2">难度反推</el-menu-item>
            <el-menu-item index="3">回收站</el-menu-item>
        </el-menu>
        
        <div class="body">
            <div v-if="activeIndex == '1'">
                <div class="title-box">
                    <span class="title">试题列表</span>
                    <span class="num">共 {{myTotal}} 条记录</span>
                    <span title="刷新" @click="myRefresh" class="el-icon-refresh-right"></span>
                </div>
                <div class="operation">
                    <el-form :inline="true" :model="myFormItem" class="demo-form-inline">
                        <el-form-item>
                            <el-select clearable size="small" v-model="myFormItem.collection" placeholder="请选择题库">
                                <el-option-group
                                    v-for="group in bankOptions"
                                    :key="group.label"
                                    :label="group.label">
                                    <el-option
                                        v-for="item in group.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select size="small" v-model="myFormItem.quesType" placeholder="请选择题型">
                                <el-option
                                v-for="item in quesTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select size="small" v-model="myFormItem.difficulty" placeholder="请选择难易度">
                                <el-option
                                v-for="item in difficultyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" @click="myRefresh">重置</el-button>
                            <el-button size="small" type="primary" @click="onMySerach">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div>
                        <el-popconfirm
                                class="popconfirm"
                                title="确定删除已选中的试题吗？"
                                @confirm="onDelMyLists"
                            >
                            
                            <el-button slot="reference" size="small" type="danger">删除</el-button>
                        </el-popconfirm>
                    </div>
                </div>
                <el-table
                    v-loading="myTableLoading"
                    ref="multipleMYTable"
                    :data="myTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="myHandleSelectionChange"
                >
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        label="试题名称"
                        width="200"
                    >
                        <template slot-scope="scope">
                            <span v-html="scope.row.quesName"></span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        align="center"
                        prop="name"
                        label="所属题库"
                    ></el-table-column>
                    
                    <el-table-column
                        align="center"
                        prop="typeName"
                        label="题型"
                    >
                    </el-table-column>

                    <el-table-column
                        align="center"
                        label="难易度"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.difficulty == 1">易</span>
                            <span v-else-if="scope.row.difficulty == 2">较易</span>
                            <span v-else-if="scope.row.difficulty == 3">中</span>
                            <span v-else-if="scope.row.difficulty == 4">较难</span>
                            <span v-else-if="scope.row.difficulty == 5">难</span>
                            <span v-else>暂无</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="citedByNum"
                        label="使用次数"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="address"
                        width="300"
                        label="操作"
                    >
                        <template slot-scope="scope">
                            <el-popover
                                style="margin-right: 10px;"
                                placement="left"
                                width="800"
                                trigger="click"
                            >
                                <ExamQuesTemplate v-if="paper.questionsList" :istestPreview="true" ref="examQuesTemplate" :paper="paper"></ExamQuesTemplate>
                                 <el-link slot="reference" type="primary" :underline="false" @click="myPreview(scope.row)">预览</el-link>
                            </el-popover>
                            <el-link type="primary" :underline="false" @click="myEdit(scope.row)">编辑</el-link>
                            <el-popconfirm
                                class="popconfirm"
                                title="确定删除该试题吗？"
                                @confirm="myDelete(scope.row)"
                            >
                                <el-link slot="reference" type="primary" :underline="false">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-box">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="myPageSize"
                        @current-change="myCurrentChange"
                        :total="myTotal">
                    </el-pagination>
                </div>
            </div>
            <div v-if="activeIndex == '2'">
                <div class="title-box">
                    <span class="title">难易度调整</span>
                    <span class="num">根据考试结果调整试题难易度 </span>
                    <span title="刷新" @click="DDRefresh" class="el-icon-refresh-right"></span>
                </div>
                <div class="operation-DD">
                    <div>
                        <el-popconfirm
                            style="margin-right: 10px;"
                            class="popconfirm"
                            title="确定批量反推当前选中项吗？"
                            @confirm="batchBackstepping"
                        >
                            <el-button size="small" slot="reference" type="primary">批量反推</el-button>
                        </el-popconfirm>
                        <el-button size="small" @click="toSetThreshold" type="primary">设置阈值</el-button>
                    </div>
                </div>
                <el-table
                    v-loading="DDTableLoading"
                    ref="multipleDDTable"
                    :data="DDTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="DDHandleSelectionChange"
                >
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55"
                    ></el-table-column>
                    
                    <el-table-column
                        align="center"
                        label="题库编号"
                        width="120"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.ques_no ? scope.row.ques_no : '暂无'}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        align="center"
                        prop="name"
                        label="题库名称"
                        width="120"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        label="试题名称"
                        width="200"
                    >
                        <template slot-scope="scope">
                            <span v-html="scope.row.quesName"></span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column
                        align="center"
                        prop="userName"
                        label="负责人"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="errorNum"
                        label="错题数"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.errorNum || 0}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="answerNum"
                        label="答题数"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.answerNum || 0}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="address"
                        label="原始难易度"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.difficulty == 1">易</span>
                            <span v-else-if="scope.row.difficulty == 2">较易</span>
                            <span v-else-if="scope.row.difficulty == 3">中</span>
                            <span v-else-if="scope.row.difficulty == 4">较难</span>
                            <span v-else-if="scope.row.difficulty == 5">难</span>
                            <span v-else>暂无</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="反推难易度"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.newDifficulty == '1.0'">易</span>
                            <span v-else-if="scope.row.newDifficulty == '2.0'">较易</span>
                            <span v-else-if="scope.row.newDifficulty == '3.0'">中</span>
                            <span v-else-if="scope.row.newDifficulty == '4.0'">较难</span>
                            <span v-else-if="scope.row.newDifficulty == '5.0'">难</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="address"
                        width="300"
                        label="操作"
                    >
                        <template slot-scope="scope">
                            <el-popover
                                style="margin-right: 10px;"
                                placement="left"
                                width="400"
                                trigger="click"
                            >
                                <ExamQuesTemplate v-if="paper.questionsList" :istestPreview="true" :paper="paper"></ExamQuesTemplate>
                                <el-link slot="reference" type="primary" :underline="false" @click="DDInfo(scope.row)">预览</el-link>
                            </el-popover>
                            <el-popconfirm
                                class="popconfirm"
                                title="确定反推该试题吗？"
                                @confirm="DDBackstepping(scope.row)"
                            >
                                <el-link slot="reference" type="primary" :underline="false">确认反推</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-box">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="DDPageSize"
                        @current-change="DDCurrentChange"
                        :total="DDTotal">
                    </el-pagination>
                </div>
            </div>
            
            <div v-if="activeIndex == '3'">
                <div class="title-box">
                    <span class="title">试题回收站</span>
                    <span class="num">已删除试题管理</span>
                    <span title="刷新" @click="RBRefresh" class="el-icon-refresh-right"></span>
                </div>
                <div class="operation">
                    <el-form :inline="true" :model="RBFormItem" class="demo-form-inline">
                        <el-form-item>
                            <el-select size="small" v-model="RBFormItem.collection" placeholder="请选择题库">
                                <el-option-group
                                    v-for="group in bankOptions"
                                    :key="group.label"
                                    :label="group.label">
                                    <el-option
                                        v-for="item in group.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select size="small" v-model="RBFormItem.quesType" placeholder="请选择题型">
                                <el-option
                                v-for="item in quesTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select size="small" v-model="RBFormItem.difficulty" placeholder="请选择题型">
                                <el-option
                                v-for="item in difficultyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" @click="RBRefresh">重置</el-button>
                            <el-button size="small" type="primary" @click="onRBSerach">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div>
                        
                        <el-popconfirm
                                class="popconfirm"
                                title="确定删除已选中的试题吗？"
                                @confirm="onDelRBLists"
                            >
                            <el-button slot="reference" size="small" type="danger">删除</el-button>
                        </el-popconfirm>
                    </div>
                </div>
                <el-table
                    v-loading="RBTableLoading"
                    ref="multipleRBTable"
                    :data="RBTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="RBHandleSelectionChange"
                >
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        label="试题名称"
                        width="200"
                    >
                        <template slot-scope="scope">
                            <span v-html="scope.row.quesName"></span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        align="center"
                        prop="name"
                        label="所属题库"
                    ></el-table-column>
                    
                    <el-table-column
                        align="center"
                        prop="typeName"
                        label="题型"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        label="难易度"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.difficulty == 1">易</span>
                            <span v-else-if="scope.row.difficulty == 2">较易</span>
                            <span v-else-if="scope.row.difficulty == 3">中</span>
                            <span v-else-if="scope.row.difficulty == 4">较难</span>
                            <span v-else-if="scope.row.difficulty == 5">难</span>
                            <span v-else>暂无</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="citedByNum"
                        label="使用次数"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="address"
                        width="300"
                        label="操作"
                    >
                        <template slot-scope="scope">
                            
                            <el-popconfirm
                                class="popconfirm"
                                title="确定恢复该试题吗？"
                                @confirm="RBRecovery(scope.row)"
                            >
                                <el-link slot="reference" type="primary" :underline="false">恢复</el-link>
                            </el-popconfirm>
                            <el-popconfirm
                                class="popconfirm"
                                title="确定删除该试题吗？"
                                @confirm="RBDelete(scope.row)"
                            >
                                <el-link slot="reference" type="primary" :underline="false">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-box">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="RBPageSize"
                        @current-change="RBCurrentChange"
                        :total="RBTotal">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
            class="dialogThreshold"
            title="阈值设置"
            :visible.sync="dialogThreshold"
            :before-close="handleCloseThreshold"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div>
                <p class="title-threshold">未知难易度时</p>
                <el-form label-width="60px" :inline="true" :model="formThresholdUNK" class="demo-form-inline">
                    <el-form-item 
                        v-for="(info, index) in DDlist"
                        :key="index"
                        :label="info.value">
                        <el-select 
                            size="mini" 
                            style="width: 120px;" 
                            v-model="formThresholdUNK[info.label]"
                            >
                            
                            <template v-for="item in difficultyValue">
                                <el-option
                                    v-if="index != 0 && item.value > formThresholdUNK[DDlist[index - 1].label]"
                                    :key="item.value"
                                    :label="item.label" 
                                    :value="item.value"
                                >
                                </el-option>
                                <el-option
                                    v-else-if="index == 0"
                                    :key="item.value"
                                    :label="item.label" 
                                    :value="item.value"
                                >
                                </el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div>
                <p class="title-threshold">已知难易度时</p>
                <el-form :model="formThresholdKNWN">
                    <el-form-item label="每次反推错误率">
                        <el-select size="mini" style="width: 100px;" @change="ascendingChange" v-model="formThresholdKNWN.up">
                            <el-option
                                v-for="item in difficultyValueKNWN1"
                                :key="item.value"
                                :label="item.label" 
                                :value="item.value"
                            ></el-option>
                        </el-select> 时
                        <span class="tip">难易度在已定级别基础上按易、较易、中、较难、难的级别依次升级</span>
                    </el-form-item>
                    <el-form-item label="每次反推错误率">
                        <el-select size="mini" style="width: 100px;" @change="descendingChange" v-model="formThresholdKNWN.down">
                            <el-option
                                v-for="item in difficultyValueKNWN2"
                                :key="item.value"
                                :label="item.label" 
                                :value="item.value"
                            ></el-option>
                        </el-select> 时
                        <span class="tip">难易度在已定级别基础上按难、较难、中、较易、易的级别依次降级</span>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="cancelThreshold">取 消</el-button>
                <el-button size="medium" type="primary" @click="setThreshold">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import ExamQuesTemplate from "@/components/examQuesTemplate/index.vue"
import Paper from "@/components/examQuesTemplate/js/Paper.js"
import { mapState } from "vuex"
export default {
    name: 'TestQuestionManagement',
    components: {
        ExamQuesTemplate
    },
    data() {
        return {
            paper: {},
            activeIndex: '1',
            myFormItem: {
                collection: '',
                quesType: '',
                difficulty: ''
            },
            myTableData: [],
            myTotal: 0,
            myPageSize: 10,
            myPageIndex: 1,
            myMultipleSelection: [],
            myTableLoading: false,
            difficultyList: [
                {
                    value: '',
                    label: '全部'
                },
                {
                    value: 1,
                    label: '易'
                },
                {
                    value: 2,
                    label: '较易'
                },
                {
                    value: 3,
                    label: '中'
                },
                {
                    value: 4,
                    label: '较难'
                },
                {
                    value: 5,
                    label: '难'
                }
            ], 
            // 题库
            bankOptions: [
                {
                    label: '自建题库',
                    options: []
                },
                {
                    label: '系统题库',
                    options: []
                }
            ],
            RBFormItem: {
                collection: '',
                quesType: '',
                difficulty: ''
            },
            RBTableData: [],
            RBTotal: 0,
            RBPageSize: 10,
            RBPageIndex: 1,
            RBMultipleSelection: [],
            RBTableLoading: false,
            DDTableData: [],
            DDTotal: 0,
            DDPageSize: 10,
            DDPageIndex: 1,
            DDMultipleSelection: [],
            DDTableLoading: false,
            dialogThreshold: false,
            difficultyValue: [
                {
                    value: 0.1,
                    label: '≦ 10%',
                },
                {
                    value: 0.2,
                    label: '≦ 20%',
                },
                {
                    value: 0.3,
                    label: '≦ 30%',
                },
                {
                    value: 0.4,
                    label: '≦ 40%',
                },
                {
                    value: 0.5,
                    label: '≦ 50%',
                },
                {
                    value: 0.6,
                    label: '≦ 60%',
                },
                {
                    value: 0.7,
                    label: '≦ 70%',
                },
                {
                    value: 0.8,
                    label: '≦ 80%',
                },
                {
                    value: 0.9,
                    label: '≦ 90%',
                },
                {
                    value: 1,
                    label: '≦ 100%',
                }
            ],
            formThresholdUNK: {
                level1: 0.2,
                level2: 0.4,
                level3: 0.6,
                level4: 0.8,
                level5: 1,
            },
            DDlist: [
                {
                    value: '易',
                    label: 'level1'
                },
                {
                    value: '较易',
                    label: 'level2'
                },
                {
                    value: '中',
                    label: 'level3'
                },
                {
                    value: '较难',
                    label: 'level4'
                },
                {
                    value: '难',
                    label: 'level5'
                }
            ],
            formThresholdKNWN: {
                up: 0.5,
                down: 0.5
            },
            difficultyValueKNWN1: [
                {
                    value: 0.1,
                    label: '>10%'
                },
                {
                    value: 0.2,
                    label: '>20%'
                },
                {
                    value: 0.3,
                    label: '>30%'
                },
                {
                    value: 0.4,
                    label: '>40%'
                },
                {
                    value: 0.5,
                    label: '>50%'
                },
                {
                    value: 0.6,
                    label: '>60%'
                },
                {
                    value: 0.7,
                    label: '>70%'
                },
                {
                    value: 0.8,
                    label: '>80%'
                },
                {
                    value: 0.9,
                    label: '>90%'
                },
                {
                    value: 1,
                    label: '>100%'
                },
            ],
            difficultyValueKNWN2: [
                {
                    value: 0.1,
                    label: '<10%'
                },
                {
                    value: 0.2,
                    label: '<20%'
                },
                {
                    value: 0.3,
                    label: '<30%'
                },
                {
                    value: 0.4,
                    label: '<40%'
                },
                {
                    value: 0.5,
                    label: '<50%'
                },
                {
                    value: 0.6,
                    label: '<60%'
                },
                {
                    value: 0.7,
                    label: '<70%'
                },
                {
                    value: 0.8,
                    label: '<80%'
                },
                {
                    value: 0.9,
                    label: '<90%'
                },
                {
                    value: 1,
                    label: '<100%'
                },
            ],
            thresholdId: ''
        }
    },
    computed: {
		...mapState(['examQuesTypeArr']),
        quesTypeList() {
            let data = [{
                value: '',
                label: '不限'
            }]
            data = [...data, ...this.examQuesTypeArr]
            return data
        }
    },
    created() {
        this.handleSelect('1')
        this.getBankOptions()
    },
    methods: {
        ascendingChange(e) {
            console.log(e)
            this.difficultyValueKNWN2.forEach((info) => {
                if (info.value == e) {
                    this.formThresholdKNWN.down = info.value
                }
            })
        },
        descendingChange(e){
            this.difficultyValueKNWN1.forEach((info) => {
                if (info.value.indexOf(e) !== -1) {
                    this.formThresholdKNWN.up = info.value
                }
            })
        },
        toSetThreshold(){
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankGetDifficultyConf}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.formThresholdUNK = {
                            level1: res.resultBody.unknownConf1,
                            level2: res.resultBody.unknownConf2,
                            level3: res.resultBody.unknownConf3,
                            level4: res.resultBody.unknownConf4,
                            level5: res.resultBody.unknownConf5,
                        }
                        that.thresholdId = res.resultBody.id
                        that.formThresholdKNWN = {
                            up: res.resultBody.addConf,
                            down: res.resultBody.addConf
                        }
                    }
                },
            };
            this.$util.request(params);
            this.dialogThreshold = true
        },
        getBankOptions() {
            this.getBankApi(0)
            this.getBankApi(1)
        },
        getBankApi(isSystem) {
            let that = this
            let data = this.$qs.stringify({
                'isSystem': isSystem, // 0自建题库 1系统题库
                'pageIndex': 1,
                'pageSize': 10000,
                'bankType': 0,
            })
            let params = {
                that: this,
                url: `${this.$config.service.examBankList}?${data}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        if (isSystem == 0) {
                            res.resultBody.datas.forEach((info) => {
                                that.bankOptions[0].options.push({
                                    label: info.name,
                                    value: info.id
                                })
                            })
                        } else {
                            res.resultBody.datas.forEach((info) => {
                                that.bankOptions[1].options.push({
                                    label: info.name,
                                    value: info.id
                                })
                            })
                        }
                    } else {
                        that.bankOptions = [{
                            label: '自建题库',
                            options: []
                        },
                        {
                            label: '系统题库',
                            options: []
                        }]
                    }
                },
            };
            this.$util.request(params);
        },
        handleSelect(key) {
            this.activeIndex = key
            if (this.activeIndex == '1') {
                this.getData(false)
            }else if (this.activeIndex == '2'){
                this.getcollData()
            }else {
                this.getData(true)
            }
        },
        getData(state) {
            this.myTableLoading = true
            this.RBTableLoading = true
            let that = this
            let data = this.$qs.stringify({
                'bankId': state ? this.RBFormItem.collection : this.myFormItem.collection, // 0自建题库 1系统题库
                'difficulty': state ? this.RBFormItem.difficulty : this.myFormItem.difficulty,
                'pageIndex': this.myPageIndex,
                'pageSize': this.myPageSize,
                'type': state ? this.RBFormItem.quesType : this.myFormItem.quesType, // 题库类别
                'isDel': state ? 1 : 0, // 是否为回收站列表
                'bankType': 0, // 是否为0考试 1问卷
                'isAdmin': 1 // 是否查询所有题库
            })
            let params = {
                that: this,
                url: `${this.$config.service.examBankQuesList}?${data}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    that.myTableLoading = false
                    that.RBTableLoading = false
                    if (res.code == '0'){
                        if (state) {
                            that.RBTableData = res.resultBody.datas
                            that.RBTotal = res.resultBody.total
                            that.RBTableData.forEach(info => {
                                that.$set(info, 'typeName', '单选')
                                switch(info.type) {
                                    case '100':
                                        info.typeName = '单选'
                                        break
                                    case '101':
                                        info.typeName = '多选'
                                        break
                                    case '102':
                                        info.typeName = '判断'
                                        break
                                    case '204':
                                        info.typeName = '填空'
                                        break
                                    case '206':
                                        info.typeName = '简答'
                                        break
                                    case '207':
                                        info.typeName = '多项填空'
                                        break
                                    case '208':
                                        info.typeName = '横向填空'
                                        break
                                    case '403':
                                        info.typeName = '上传文件'
                                        break
                                    case '209':
                                        info.typeName = '绘图'
                                        break
                                    case '401':
                                        info.typeName = '段落标题'
                                        break
                                }
                            })
                        } else {
                            that.myTableData = res.resultBody.datas
                            that.myTotal = res.resultBody.total
                            that.myTableData.forEach(info => {
                                that.$set(info, 'typeName', '单选')
                                switch(info.type) {
                                    case '100':
                                        info.typeName = '单选'
                                        break
                                    case '101':
                                        info.typeName = '多选'
                                        break
                                    case '102':
                                        info.typeName = '判断'
                                        break
                                    case '204':
                                        info.typeName = '填空'
                                        break
                                    case '206':
                                        info.typeName = '简答'
                                        break
                                    case '207':
                                        info.typeName = '多项填空'
                                        break
                                    case '208':
                                        info.typeName = '横向填空'
                                        break
                                    case '403':
                                        info.typeName = '上传文件'
                                        break
                                    case '209':
                                        info.typeName = '绘图'
                                        break
                                    case '401':
                                        info.typeName = '段落标题'
                                        break
                                    
                                }
                            })
                            console.log(that.myTableData)
                        }
                    } else {
                        that.myTableData = []
                        that.myTotal = 0
                        that.RBTableData = []
                        that.RBTotal = 0
                    }
                },
            };
            this.$util.request(params);
        },
        getcollData() {
            this.collTableLoading = true
            let that = this
            let data = this.$qs.stringify({
                'pageIndex': this.DDPageIndex,
                'pageSize': this.DDPageSize,
                'bankType': 0,
            })
            let params = {
                that: this,
                url: `${this.$config.service.examBankInferenceList}?${data}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    that.collTableLoading = false
                    if (res.code == '0'){
                        that.DDTableData = res.resultBody.datas
                        that.DDTotal = res.resultBody.total
                    } else {
                        that.DDTableData = []
                        that.DDTotal = 0
                    }
                },
            };
            this.$util.request(params);
        },
        myCurrentChange(e) {
            this.myPageIndex = e
            // 刷新列表
            this.getData(false)
        },
        myDelete(item) {
            let arr = [{
                bankId: item.bid,
                id: item.id
            }]
            this.saveMyDelApi(arr)
        },
        onDelMyLists() {
            let arr = []
            if (this.myMultipleSelection.length == 0) {
                this.$message({
                    message: '请先选择要删除的试题',
                    type: 'warning'
                });
                return
            }
            this.myMultipleSelection.forEach(info => {
                arr.push({
                    bankId: info.bid,
                    id: info.id
                })
            })
            this.saveMyDelApi(arr)
        },
        saveMyDelApi(ids) {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankDelQues}`,
                method: "POST",
                data: ids,
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.$message({
                            message: res.message,
                            type: 'success'
                        });
                        that.getData(false)
                    } else {
                        that.$message.error(res.message);
                    }
                },
            };
            this.$util.request(params);
        },
        myRefresh() {
            this.onMyReset()
            this.getData(false)
        },
        onMyReset() {
            this.myPageIndex = 1
            this.myFormItem = {
                collection: '',
                quesType: '',
                difficulty: ''
            }
        },
        onMySerach() {
            this.myPageIndex = 1
            this.getData(false)
        },
        myPreview(item) {
            // 我的试题预览
            this.paper = new Paper() // 初始化paper
            this.paper.questionsList.push(JSON.parse(item.quesJson))
        },
        DDInfo(item) {
            // 难度反推试题预览
            this.paper = new Paper() // 初始化paper
            this.paper.questionsList.push(JSON.parse(item.quesJson))
        },
        myEdit(item) {
            console.log(item)
            // 打开试题设计页面
            this.$router.push({
                path: '/editQuestion',
                query: {
                    id: item.id,
                    bid: item.bid,
                    isTestEdit: true
                }
            })
        },
        myHandleSelectionChange(val) {
            console.log(val)
            this.myMultipleSelection = val;
        },
        RBRefresh() {
            this.onRBReset()
            this.getData(true)
        },
        onRBReset() {
            this.RBPageIndex = 1
            this.RBFormItem = {
                collection: '',
                quesType: '',
                difficulty: ''
            }
        },
        onRBSerach() {
            this.RBPageIndex = 1
            this.getData(true)
        },
        RBHandleSelectionChange(val) {
            console.log(val)
            this.RBMultipleSelection = val;
        },
        RBRecovery(item) {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankRecycleBinRenew}?id=${item.id}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.$message({
                            message: res.message,
                            type: 'success'
                        });
                        that.getData(true)
                    } else {
                        that.$message.error(res.message);
                    }
                },
            };
            this.$util.request(params);
        },
        RBDelete(item) {
            let arr = [item.id]
            this.saveRBDelApi(arr)
        },
        onDelRBLists() {
            let arr = []
            if (this.RBMultipleSelection.length == 0) {
                this.$message({
                    message: '请先选择要删除的试题',
                    type: 'warning'
                });
                return
            }
            this.RBMultipleSelection.forEach(info => {
                arr.push(info.id)
            })
            this.saveRBDelApi(arr)
        },
        saveRBDelApi(ids) {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankRecycleBinDel}?ids=${ids}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.$message({
                            message: res.message,
                            type: 'success'
                        });
                        that.getData(true)
                    } else {
                        that.$message.error(res.message);
                    }
                },
            };
            this.$util.request(params);
        },
        RBCurrentChange(e) {
            this.RBPageIndex = e
            this.getData(true)
        },
        DDRefresh() {
            this.DDPageIndex = 1
            this.getcollData()
        },
        DDHandleSelectionChange(val) {
            console.log(val)
            this.DDMultipleSelection = val;
        },
        DDCurrentChange(e) {
            this.DDPageIndex = e
            this.getcollData()
        },
        DDBackstepping(info) {
            let arr = [{
                bid: info.bid,
                difficulty: info.difficulty,
                newDifficulty: info.newDifficulty,
                qid: info.id,
            }]
            this.saveBacksteppingApi(arr)
        },
        batchBackstepping() {
            // 批量反推
            let arr = []
            this.DDMultipleSelection.forEach(info => {
                arr.push({
                    bid: info.bid,
                    difficulty: info.difficulty,
                    newDifficulty: info.newDifficulty,
                    qid: info.id,
                })
            })
            this.saveBacksteppingApi(arr)
        },
        saveBacksteppingApi(arr) {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankInference}`,
                method: "POST",
                data: arr,
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.getcollData()
                        that.$message({
                            message: res.message,
                            type: 'success'
                        });
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        handleCloseThreshold() {
            // 关闭前清除数据
            this.dialogThreshold = false
        },
        cancelThreshold () {
            this.dialogThreshold = false
        },
        setThreshold() {
            // 确定
            
            let that = this
            let data = {
                addConf: this.formThresholdKNWN.up,
                id: this.thresholdId,
                unknownConf1: this.formThresholdUNK.level1,
                unknownConf2: this.formThresholdUNK.level2,
                unknownConf3: this.formThresholdUNK.level3,
                unknownConf4: this.formThresholdUNK.level4,
                unknownConf5: this.formThresholdUNK.level5
            }
            let params = {
                that: this,
                url: `${this.$config.service.examBankAddDifficultyConf}`,
                method: "POST",
                data: data,
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.dialogThreshold = false
                        that.$message({
                            message: res.message,
                            type: 'success'
                        });
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
            console.log(this.formThresholdUNK)
        }
    }
}
</script>

<style lang="scss" scoped>
.TestQuestionManagement{
    /deep/.el-menu{
        position: static;
    }
    .el-menu-demo{
        padding-left: 20px;
        border-bottom: 1px solid #bbb;
    }
    /deep/.el-menu--horizontal>.el-menu-item.is-active,
    /deep/.el-menu--horizontal>.el-menu-item{
        border-bottom: none !important;
    }
    /deep/.el-menu-item{
        font-size: 16px;
    }
    .el-icon-refresh-right{
        cursor: pointer;
    }
    .body{
        padding: 0 40px 50px 40px;
        .title-box{
            line-height: 42px;
            span{
                font-size: 12px;
                color: #A7A6A6;
            }
            .title{
                font-size: 14px;
                color: #696868;
            }
            span+span{
                margin-left: 10px;
            }
        }
        .operation{
            display: flex;
            justify-content: space-between;
        }
        .operation-DD{
            height: 62px;
            display: flex;
            justify-content: flex-end;
        }
        .page-box{
            margin-top: 20px;
            text-align: center;
        }
        .popconfirm{
            margin-left: 10px;
        }
    }
    .title-threshold{
        margin-bottom: 20px;
    }
    .dialogThreshold{
        /deep/.el-dialog{
            width: 650px;
        }
        .tip{
            display: inline-block;
            margin-left: 5px;
            font-size: 12px;
            color: #848383;
        }
    }
}
</style>
